import React from 'react';

function CaboVerde(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124156)">
        <mask
          id="mask0_800_124156"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124156)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#4141DB"
          />
          <mask
            id="mask1_800_124156"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124156)">
            <path
              d="M0 13H-1V14V16V17H0H36H37V16V14V13H36H0Z"
              fill="#F90000"
              stroke="#F7FCFF"
              strokeWidth="2"
            />
            <g filter="url(#filter0_d_800_124156)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0205 10.2595L11.8371 9.7506L12.6272 10.2595L12.3816 9.35387L13.0161 8.77996H12.2085L11.836 8.04089L11.5182 8.77996H10.5709L11.2962 9.35387L11.0205 10.2595ZM14.3955 11.8595L15.2121 11.3506L16.0022 11.8595L15.7566 10.9539L16.3911 10.38H15.5835L15.211 9.6409L14.8932 10.38H13.9459L14.6712 10.9539L14.3955 11.8595ZM17.9121 13.7506L17.0955 14.2595L17.3712 13.3539L16.6459 12.78H17.5933L17.911 12.0409L18.2836 12.78H19.0912L18.4566 13.3539L18.7023 14.2595L17.9121 13.7506ZM17.0955 18.2595L17.9121 17.7506L18.7023 18.2595L18.4566 17.3539L19.0912 16.78H18.2836L17.911 16.0409L17.5933 16.78H16.6459L17.3712 17.3539L17.0955 18.2595ZM15.2121 20.1506L14.3955 20.6595L14.6712 19.7539L13.9459 19.18H14.8932L15.211 18.4409L15.5835 19.18H16.3911L15.7566 19.7539L16.0022 20.6595L15.2121 20.1506ZM11.0205 22.2595L11.8371 21.7506L12.6272 22.2595L12.3816 21.3539L13.0161 20.78H12.2085L11.836 20.0409L11.5182 20.78H10.5709L11.2962 21.3539L11.0205 22.2595ZM8.46211 20.1506L7.6455 20.6595L7.9212 19.7539L7.19589 19.18H8.14324L8.46097 18.4409L8.83354 19.18H9.64113L9.00659 19.7539L9.25224 20.6595L8.46211 20.1506ZM4.94546 18.2595L5.76207 17.7506L6.5522 18.2595L6.30655 17.3539L6.94109 16.78H6.1335L5.76093 16.0409L5.4432 16.78H4.49585L5.22116 17.3539L4.94546 18.2595ZM5.76207 13.7506L4.94546 14.2595L5.22116 13.3539L4.49585 12.78H5.4432L5.76093 12.0409L6.1335 12.78H6.94109L6.30655 13.3539L6.5522 14.2595L5.76207 13.7506ZM7.6455 11.8595L8.46211 11.3506L9.25224 11.8595L9.00659 10.9539L9.64113 10.38H8.83354L8.46097 9.6409L8.14324 10.38H7.19589L7.9212 10.9539L7.6455 11.8595Z"
                fill="#FFDE00"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_800_124156"
          x="0.49585"
          y="4.04089"
          width="22.5952"
          height="22.2186"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_800_124156"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_800_124156"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_800_124156">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CaboVerde;
